module.exports = __webpack_public_path__ + "static/img/contant_4.bd56b48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_13/contant_4.jpg
// module id = 0O9N
// module chunks = 0